import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

function ButtonLoading({ height, width }) {
  return <CircularProgress style={{ height, width }} />;
}

export default ButtonLoading;
